var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebIconsCostos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "be828c87-6801-47ba-8bd6-c9a29d7204f6",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.62,49.11l31.13,32a9.39,9.39,0,0,0,12.86.56L311,58.07V341.7l-26.76-23.94a10.39,10.39,0,0,0-14.27.36l-31,30.75-32.8-30.72a10,10,0,0,0-13.83.19l-30.83,30.53-31.14-30.56a10.32,10.32,0,0,0-14.06-.36L89,342.06v-284l27.79,24a9.43,9.43,0,0,0,12.84-.46l32.52-32.52,29.38,31.46a11.83,11.83,0,0,0,17.11.2l31-31.66M67,58.07V363.3a12.45,12.45,0,0,0,20.7,9.32l15.91-14.08,19.06-16.87L146,364.59l8.57,8.41a9.83,9.83,0,0,0,13.8,0l8.54-8.46,22.58-22.36,24.32,22.79,8.57,8a9.83,9.83,0,0,0,13.64-.18l8.34-8.27,23.28-23.06,18.62,16.66,15.27,13.66A12.85,12.85,0,0,0,333,362.19V35.27a11.58,11.58,0,0,0-19.14-8.77L296.59,41.4,278.24,57.25,255.41,33.76,251,29.23a15.85,15.85,0,0,0-22.7,0l-4.42,4.52-23.51,24L178.26,34.08l-4.35-4.66a15.85,15.85,0,0,0-22.8-.39l-4.51,4.51L122.35,57.79,103.42,41.42,85.66,26.05A11.28,11.28,0,0,0,67,34.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.37,
    y: 122.25,
    width: 155.26,
    height: 22.23,
    rx: 11.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.37,
    y: 187.87,
    width: 155.26,
    height: 22.23,
    rx: 11.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.37,
    y: 253.49,
    width: 155.26,
    height: 22.23,
    rx: 11.12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIconsCostos);
export default __webpack_public_path__ + "static/media/web-icons_costos.693d67955eb2016676a950e003278bb7.svg";
export { ForwardRef as ReactComponent };